module.exports = __webpack_public_path__ + "static/img/start.294a384.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/videoBg/Melon/start.jpg
// module id = 1QX6
// module chunks = 1